import {
  STICKY_BANNER_RULE_TYPES,
  BEHAVIOR_MODES,
  SCROLL_RESOLUTION,
  STICKY_PAGE_TYPES,
  STICKY_BANNER_EVENT_TYPES
} from "./stickyBannerConfig.types";
import { mergeStickyBannerConfig } from "./commonConfig";

/**
 * Maths Olympiad report — same milestone scroll model as standard reports
 * (`BasicReport` anchors), with Maths-specific score matrix via
 * `stickyBannerEventType: MATHS_OLYMPIAD`.
 */
export const olympiadReportsStickyBannerConfig = mergeStickyBannerConfig({
  id: "olympiad-reports-page",
  pageType: STICKY_PAGE_TYPES.REPORT,
  stickyBannerEventType: STICKY_BANNER_EVENT_TYPES.MATHS_OLYMPIAD,
  behaviorMode: BEHAVIOR_MODES.SCROLL,
  scrollResolution: SCROLL_RESOLUTION.MILESTONE,

  messageRules: [],
  scrollTriggers: [],

  middleMilestoneTargetId: "tte-report-section-breakdown",
  middleScrollEnterRatio: 0.35,
  middleScrollExitRatio: 0.3,
  bottomThreshold: 0.82,

  scrollMilestones: [
    {
      id: "section-breakdown",
      order: 2,
      type: STICKY_BANNER_RULE_TYPES.SCROLL_ELEMENT,
      targetElementId: "tte-report-section-breakdown",
      threshold: 0.05,
      rootMargin: "0px 0px -12% 0px"
    },
    {
      id: "page-bottom",
      order: 3,
      type: STICKY_BANNER_RULE_TYPES.SCROLL_PERCENT,
      enterRatio: 0.82,
      exitRatio: 0.77
    }
  ]
});
